var map = {
	"./ar/canvas.json": 7222,
	"./cs/canvas.json": 34999,
	"./cy/canvas.json": 52599,
	"./da/canvas.json": 94459,
	"./de/canvas.json": 69936,
	"./en/canvas.json": 65939,
	"./es/canvas.json": 95649,
	"./fi/canvas.json": 52764,
	"./fr/canvas.json": 70395,
	"./he/canvas.json": 85029,
	"./hi/canvas.json": 80719,
	"./hr/canvas.json": 26690,
	"./hu/canvas.json": 16674,
	"./it/canvas.json": 13769,
	"./ja/canvas.json": 11952,
	"./kk/canvas.json": 52102,
	"./kn/canvas.json": 98617,
	"./ko/canvas.json": 67957,
	"./ml/canvas.json": 1368,
	"./mr/canvas.json": 49050,
	"./nl/canvas.json": 55061,
	"./pl/canvas.json": 34075,
	"./pt/canvas.json": 38805,
	"./ro/canvas.json": 24121,
	"./ru/canvas.json": 90609,
	"./sh/canvas.json": 71349,
	"./sk/canvas.json": 51289,
	"./sr/canvas.json": 8631,
	"./sv/canvas.json": 6714,
	"./ta/canvas.json": 83444,
	"./te/canvas.json": 35242,
	"./vi/canvas.json": 46427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85553;